import styled, {css} from "styled-components";

const GROUP_GAP_REM = 1.6;

export const StyledCardRadioGroup = styled.div<{
  $stackOnMobile?: boolean;
  $twoPerRow?: boolean;
}>`
  display: flex;
  gap: ${GROUP_GAP_REM}rem;
  width: 100%;

  ${(p) =>
    p.$twoPerRow &&
    css`
      flex-wrap: wrap;

      /* Half the row minus its share of the gap. The cap is what keeps an odd card out
         at the width it would have had on a full row instead of stretching across one
         of its own; the card still shrinks on a narrow screen exactly as it did before.
         !important because a tooltip-wrapped card carries an inline \`flex: 1\`, which
         is also why this block stays above \`$stackOnMobile\` — the two size the same
         children, and stacking has to be the one that wins. */
      > * {
        flex: 1 1 calc(50% - ${GROUP_GAP_REM / 2}rem) !important;
        max-width: calc(50% - ${GROUP_GAP_REM / 2}rem);
      }
    `}

  ${(p) =>
    p.$stackOnMobile &&
    css`
      @media screen and (max-width: 960px),
        screen and (pointer: coarse) and (max-width: 1024px) {
        flex-direction: column;
        align-items: stretch;

        > * {
          flex: none !important;
          width: 100%;
          max-width: 100%;
        }
      }
    `}
`;

export const StyledCardRadioOption = styled.div<{
  $selected: boolean;
  $disabled?: boolean;
}>`
  flex: 1;
  background-color: ${(props) => (props.$selected ? "#f5f3ff" : "#ffffff")};
  border: 1px solid ${(props) => (props.$selected ? "#1c1726" : "#f0f0f0")};
  border-radius: 8px;
  padding: 1.6rem;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  position: relative;

  &:hover {
    ${(props) =>
      !props.$disabled &&
      `
      border-color: ${props.$selected ? "#1c1726" : "#d9d9d9"};
    `}
  }

  input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
`;

export const StyledCardRadioContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const StyledCardRadioTitle = styled.div`
  font-weight: 400;
  font-size: 1.4rem;
  color: #1c1726;
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledCardRadioDescription = styled.div`
  font-size: 1.2rem;
  color: #8c8c8c;
  line-height: 1.4;
`;

export const StyledRadioIndicator = styled.div<{$selected: boolean}>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.$selected ? "#1c1726" : "#d9d9d9")};
  background-color: ${(props) => (props.$selected ? "#1c1726" : "transparent")};
  position: relative;
  flex-shrink: 0;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${(props) => (props.$selected ? "#ffffff" : "transparent")};
  }
`;
